export default {"src":"/_next/static/media/email.fdbb49be.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};